import { ComponentType } from '@/types/cml-api'

export const elementTrackingId = 'cta_click'
export const STORIES_PAGE_SIZE = 10

export const BANNERS_HEIGHT = {
    mobile: {
        [ComponentType.Banner]: 160,
        [ComponentType.SmallBanner]: 76,
    },
    desktop: {
        [ComponentType.Banner]: 224,
        [ComponentType.SmallBanner]: 96,
    },
}
